import { Fragment, useEffect, useState } from 'react';
import { NotFound } from '../../../components/NotFound';
import { useAuth } from '../../../contexts/AuthProvider';
import { AccountTrialBalanceModel, AccountTrialSummaryModel, fetctAgentAccountTrialBalance } from '../../../model/account.model';
import { parseFixed, numberDisplay, toDrCr, getDrCrColor } from '../../../services/formats';
import { PageContainer } from '../../../components/PageContainer';
import { Form, ListGroup } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';
import Badge from '../../../components/Badge';

export default function AgentAccountTrialBalance() {
  const { isLoading, showLoader, hideLoader } = useUtility();
  const [summary, setSummary] = useState<AccountTrialSummaryModel>({
    opening_diff: 0,
    trial_diff: 0,
    credit: 0,
    debit: 0,
    amt: 0,
  });
  const [trialBalanceList, setTrialBalanceList] = useState<Record<string, Array<AccountTrialBalanceModel>>>({});
  const [filteredList, setFilteredList] = useState<Record<string, Array<AccountTrialBalanceModel>>>({});
  const { authInfo, globalSearch } = useAuth();

  const updateSummary = (data: Record<string, Array<AccountTrialBalanceModel>>) => {
    let credit = 0, debit = 0;
    Object.entries(data).forEach(([ag_name, items], idx) => {
      items.forEach(item => {
        credit += parseFixed(item.credit);
        debit += parseFixed(item.debit);
      });
    });
    setSummary(prev => ({
      ...prev,
      credit,
      debit,
    }));
  }

  const fetchData = async (inputs: any) => {
    try {
      showLoader();
      const res = await fetctAgentAccountTrialBalance(inputs, authInfo);
      setTrialBalanceList(res.data);
      setFilteredList(res.data);
      updateSummary(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      hideLoader();
    }
  }

  useEffect(() => {
    fetchData(globalSearch.fields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalSearch.fields]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyword = e.target.value.toLowerCase();
    const filtered = Object.fromEntries(Object.entries(trialBalanceList).filter(([agent_name, list]) => agent_name.toLowerCase().includes(keyword)));
    setFilteredList(filtered);
    updateSummary(filtered);
  };

  return (
    <PageContainer
      title="Agent Account Balances"
      showSearchBtn
      body={<Fragment>
        {!isLoading && !Object.keys(trialBalanceList).length ? <NotFound /> : <Fragment>
          <Form.Group className="mb-3" controlId="itemSearch">
            <Form.Control
              type="text"
              placeholder="Search by Broker Name..."
              onChange={handleFilterChange}
            />
          </Form.Group>

          {Object.entries(filteredList).map(([agent_name, list], idx) => (
            <ListGroup key={`agent-${idx}`} className='mb-4'>
              <ListGroup.Item className="list-group-item-primary">
                <strong>{agent_name}</strong>
              </ListGroup.Item>
              {list.map((item, index) => (
                <ListGroup.Item
                  key={`agent-${idx}-account-${index}`}
                  className="d-flex justify-content-between gap-3 align-items-center">
                  <span>{item.ac_name}</span>
                  <Badge color={getDrCrColor(item.amt)} text={toDrCr(item.amt)} />
                </ListGroup.Item>
              ))}
            </ListGroup>
          ))}

          {Object.keys(filteredList).length > 0 && <Fragment>
            <p><strong>SUB TOTAL</strong></p>
            <div className="d-flex justify-content-between gap-3 align-items-center mb-4">
              <Badge color="primary" text={`${numberDisplay(summary.debit)} DR`} />
              <Badge color="warning" text={`${numberDisplay(summary.credit)} CR`} />
            </div>

            <p className="d-flex justify-content-center align-items-center">
              <strong className='text-center'>Trial Diff: {toDrCr(summary.debit - summary.credit)}</strong>
            </p>
          </Fragment>
          }

        </Fragment>
        }
      </Fragment>
      }
    />
  );
};